module.exports = __webpack_public_path__ + "media/registration/workshops@1x-ed64ab30.png";